export default __webpack_public_path__ + "static/media/flamingo2.a0ee7840.jpg";